module.exports = __webpack_public_path__ + "img/90301905.526bc99b.png";